import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-[var(--surface-page)]">
      <div className="text-center max-w-md mx-4">
        <h1 className="text-6xl font-heading font-bold text-[var(--brand)] mb-2">404</h1>
        <p className="text-lg text-[var(--content-secondary)] mb-6">Page not found</p>
        <Link
          to="/"
          className="inline-block px-6 py-2.5 rounded-button bg-[var(--brand)] text-white font-semibold hover:bg-[var(--brand-hover)] transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  )
}
